module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"impiXÔmetro","short_name":"impiXÔmetro","start_url":"/","background_color":"#000F32","theme_color":"#000F32","display":"minimal-ui","icon":"src/images/impixometro-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"8fb2b01187f46e432e066248f318c093"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
